'use client';

import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

import { ROUTES } from '@/constants/routes';

import { parseApiFailure } from '@/services/api/client';
import { register } from '@/services/auth/auth-api';

export function useRegisterMutation() {
  const router = useRouter();

  return useMutation({
    mutationFn: register,
    onSuccess: () => {
      toast.success('Account created. Please sign in.');
      router.replace(ROUTES.login);
    },
    onError: (error: unknown) => {
      const message = axios.isAxiosError(error)
        ? parseApiFailure(error).message
        : error instanceof Error
          ? error.message
          : 'Unable to register.';
      toast.error(message);
    },
  });
}
